module.exports = __webpack_public_path__ + "6c4a0dbc/img/comment-question-icon.7dd26e04.svg";